import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { first, isEmpty } from 'underscore';
import { getDomain } from '@bingads-webui/url-util';
import { extractTargetsFromViewModel } from './helpers/utils';
import { UrlRulesPreview } from './url-rules-preview';

const getSummaryStyle = () => ({
  advancedUrlOptionsSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
});

export const UrlOptionsDetailsWithRules = ({
  i18n, finalUrls, path1, path2, mobileFinalUrls, urlRules,
}) => {
  const styles = useDefaultStyles(getSummaryStyle);

  const finalUrl = first(finalUrls);
  const mobileFinalUrl = first(mobileFinalUrls);
  let displayUrl = '';
  if (!isEmpty(path1)) {
    const finalUrlDomain = getDomain(finalUrl) || 'www.example.com';
    displayUrl = `${finalUrlDomain}/${path1}`;
    if (!isEmpty(path2)) {
      displayUrl = `${displayUrl}/${path2}`;
    }
  }
  const noDisplayUrl = isEmpty(displayUrl);
  const noMboileUrl = isEmpty(mobileFinalUrl);
  const noUrlRules = isEmpty(urlRules);
  const noSettingsApplied = noDisplayUrl && noMboileUrl && noUrlRules;

  let urlPathText = '';
  if (noSettingsApplied) {
    urlPathText = i18n.getString(_TL_('No URL settings applied'));
  } else {
    if (!noDisplayUrl) {
      urlPathText += `${i18n.getString(_TL_('Display URL'))}: ${displayUrl}`;
    }
    if (!noMboileUrl) {
      if (urlPathText.length > 0) {
        urlPathText += '; '; // Add separator if there are details before
      }
      urlPathText += `${i18n.getString(_TL_('Mobile URL'))}: ${mobileFinalUrl}`;
    }
  }

  const { urlTargets } = extractTargetsFromViewModel(urlRules || []);

  const renderRulesSummary = useCallback(() => {
    if (urlRules.length === 0) {
      return (<span>{i18n.getString(_TL_('No URL rules set'))}</span>);
    }
    return (
      <>
        <span>{i18n.getString(_TL_('URL rules and custom labels'))}:</span>
        <UrlRulesPreview
          urlRules={urlRules}
          i18n={i18n}
          isSingleRow
        />
      </>
    );
  }, [urlRules, i18n, urlTargets]);

  return (
    <div className={styles.advancedUrlOptionsSummaryContainer}>
      {urlPathText}
      { !noSettingsApplied && renderRulesSummary() }
    </div>
  );
};

UrlOptionsDetailsWithRules.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  finalUrls: PropTypes.arrayOf(PropTypes.string),
  path1: PropTypes.string,
  path2: PropTypes.string,
  mobileFinalUrls: PropTypes.arrayOf(PropTypes.string),
  urlRules: PropTypes.arrayOf(PropTypes.shape({})),
};

UrlOptionsDetailsWithRules.defaultProps = {
  finalUrls: [],
  path1: '',
  path2: '',
  mobileFinalUrls: [],
  urlRules: [],
};
